import { AfterViewInit, Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { DataDetail } from '../../../../models/DataDetail';
import { ThingService } from '../../../../services/thing/thing.service';
import { Utilities } from '../../../../services/utilities/utilities';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => SimpleDropdownComponent),
  multi: true
};

@Component({
  selector: 'app-simple-dropdown',
  templateUrl: './simple-dropdown.component.html',
  styleUrls: ['./simple-dropdown.component.scss', './../dropdown-style.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class SimpleDropdownComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  propertyDisplayArgs: string[];
  _displayStringArgs: string[];
  selectString: any;
  isDisabled: boolean;
  // @Input() selectedItem: SelectedItem;
  @Input() dataUri: string;
  @Input() hint: string;
  @Input() name: string;
  @Input() bindValue: string;
  @Input() labelName: string;
  @Input() multiple: false;
  @Input() required: false;
  @Input() dataItems: any[];
  @Input() displayString: string;
  @Input() errorText: string;
  @Input() iconProperty: string;
  @Input() colourProperty: string;
  @Input() nestBy: string;
  @Input() placeholder: string;
  _selectedValue: number;
  _selectedArray: number[];
  @Input()
  set displayStringArgs(v: string[]) {
    this.propertyDisplayArgs = v ? v.map(str => Utilities.getLastEntry(str)) : [];
    this._displayStringArgs = v;
  }
  get displayStringArgs(): string[] {
    return this._displayStringArgs;
  }

  set value(val: any) {  // this value is updated by programmatic changes if( val !== undefined && this.val !== val){

    if (!this.multiple) {
      this._selectedValue = parseInt(val as any, 10);
    } else {
      this._selectedArray = val ? val : [];
    }
    this.onChange(val);
    this.onTouched(val);
  }
  get value(): any {
    if (!this.multiple) {
      return this._selectedValue;
    } else {
      return this._selectedArray;
    }
  }

  totalRecordCount: number;
  returnRecordCount: number;
  loading: boolean;
  nestLevelKey = 'nestLevel';

  @ViewChild('dropdown') public dropdown: NgSelectComponent;

  constructor(public toastr: ToastrService, private thingService: ThingService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {

    const select = this.getSelectString();

    if (this.dataItems) {
      this.returnRecordCount = this.dataItems.length;
      this.totalRecordCount = this.dataItems.length;
      this.dataItems = this.reorderData(this.dataItems);
    }

    if (this.dataUri) {
      setTimeout(() => {
        this.loading = true;
        this.thingService.getDataDetailWithHeader(this.dataUri, 0, null, null, null, null, '', select, true)
          .subscribe(results => this.onGetDataSuccessful(results), error => this.onGetDetailFailed(error))
      });
    }
  }

  writeValue(value: any): void {
    if (value !== this.value) {
      this.value = value;
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
  onChange: any = () => { };
  onTouched: any = () => { };

  private getSelectString() {
    if (!this.selectString) {
      const props = Object.assign([{}], this.propertyDisplayArgs);
      if (this.colourProperty) {
        props.push(Utilities.getLastEntry(this.colourProperty));
      }
      if (this.iconProperty) {
        if (!props.find(p => p === Utilities.getLastEntry(this.iconProperty))) {
          props.push(Utilities.getLastEntry(this.iconProperty));
        }
      }
      if (this.nestBy) {
        const p = this.nestBy.split('=');
        if (!props.find(p => p === Utilities.getLastEntry(p[0]))) {
          props.push(Utilities.getLastEntry(p[0]));
        }
        if (!props.find(p => p === Utilities.getLastEntry(p[1]))) {
          props.push(Utilities.getLastEntry(p[1]));
        }
      }
      if (this.propertyDisplayArgs.findIndex(s => s === this.bindValue) < 0) {
        if (!props.find(p => p === Utilities.getLastEntry(this.bindValue))) {
          props.push(Utilities.getLastEntry(this.bindValue));
        }
      }

      this.selectString = props.join(',');
    }
    return this.selectString;
  }

  private onGetDataSuccessful(dataDetail: DataDetail) {

    this.loading = false;
    this.dataItems = this.reorderData(dataDetail.dataItems);
    // this.dataItems = dataDetail.dataItems;
    this.returnRecordCount = dataDetail.returnRecordCount;
    this.totalRecordCount = dataDetail.totalRecordCount;

  }
  reorderData(dataItems: any[]): any[] {
    if (!this.nestBy || dataItems.length < 2) {
      return dataItems;
    }

    const p = this.nestBy.split('=');
    const nestByParentProperty = Utilities.getLastEntry(p[0]);
    const nestByChildProperty = Utilities.getLastEntry(p[1]);

    const orderedDataValues = [];
    this.nestValuesById(dataItems, null, 0, orderedDataValues, nestByParentProperty, nestByChildProperty);
    return orderedDataValues;
  }

  nestValuesById(dataValues: any[], rootId: any, nestLevel: number, orderedDataValues: any[], nestByParentProperty: string, nestByChildProperty: string) {
    if (!nestByParentProperty || !nestByChildProperty) {
      return;
    }

    dataValues.filter(d => d[nestByParentProperty] == rootId).forEach(v => {
      v[this.nestLevelKey] = nestLevel;
      orderedDataValues.push(v);
      const newRootId = v[nestByChildProperty];
      this.nestValuesById(dataValues, newRootId, nestLevel + 1, orderedDataValues, nestByParentProperty, nestByChildProperty);
    });
  }

  private onGetDetailFailed(error: any) {
    this.toastr.error(`Unable to retrieve data from the server.\r\nErrors: '${Utilities.getHttpResponseMessage(error)}'`, null, { closeButton: true, tapToDismiss: true });
    this.loading = false;
  }

  getDisplayText(item: any) {
    if (item) {
      return Utilities.parseArgumentsFromData(this.displayString, this.displayStringArgs, item);
    }
  }

  getHint()
  {
    return this.hint;
  }

  public clear() {
    this.value = null;
    this.dataItems = [];
    this.returnRecordCount = 0;
    this.totalRecordCount = 0;
  }

  public focus() {
    this.dropdown.focus();
  }

  hasIcon() {
    return this.iconProperty;
  }

  hasColor() {
    return this.colourProperty;
  }

  getIconId(item: any) {
    if (item) {
      if (this.iconProperty) {
        return Utilities.parseArgumentsFromData(null, [this.iconProperty], item);
      }
    }
  }

  getColor(item: any): string {

    if (this.colourProperty) {
      const path = Utilities.getLastEntry(this.colourProperty);

      const color: string = item[path];
      if (color && color.length > 0) {
        if (!color.startsWith('#')) {
          return '#' + color;
        } else {
          return color;
        }
      }

      return '#fff';
    }

    return '#fff';
  }

  getIndent(item: any): number {
    return (item[this.nestLevelKey] as number) * 16;
  }
}
